import {hpcAttrs} from '@github-ui/hpc'

import {Hero, Grid, Text} from '@primer/react-brand/esm'

import {PricingPlans} from '../_components/PricingPlans/PricingPlans'
import {PlanTypes} from '../_components/PlanTypes/PlanTypes'
import IdeList from '../_components/IdeList/IdeList'

import type {HeroSectionContent} from './HeroSection/content'

type Props = {
  content: HeroSectionContent
}

export function HeroSection({content}: Props) {
  const {hero, ideList, planItems, planTypes, pricingOptions} = content

  return (
    <Grid as="section" className="position-relative">
      <Grid.Column span={12}>
        {hero ? (
          <Hero align="center" className="tmp-pb-4">
            <Hero.Heading size="2" {...hpcAttrs()}>
              {hero.fields.heading}
            </Hero.Heading>
          </Hero>
        ) : null}

        {planTypes ? <PlanTypes contentfulContent={planTypes} items={planItems} /> : null}

        {pricingOptions ? <PricingPlans contentfulContent={pricingOptions} /> : null}

        <div className="tmp-mb-5">
          {ideList ? (
            <Text as="p" size="200" variant="muted" weight="normal" align="center" className="tmp-mb-5">
              {ideList.fields.heading}
            </Text>
          ) : null}

          <IdeList type="small" location="pricing-cards" />
        </div>
      </Grid.Column>
    </Grid>
  )
}
